/**
 * @generated SignedSource<<f41a8fbc46be6afc6fa58d792c49ab58>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cmsSpecialtyId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "effectiveFrom"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "effectiveTo"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "numberOfBeds"
},
v5 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "cmsSpecialtyId",
        "variableName": "cmsSpecialtyId"
      },
      {
        "kind": "Variable",
        "name": "effectiveFrom",
        "variableName": "effectiveFrom"
      },
      {
        "kind": "Variable",
        "name": "effectiveTo",
        "variableName": "effectiveTo"
      },
      {
        "kind": "Variable",
        "name": "facilityLocationCmsSpecialtyId",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "numberOfBeds",
        "variableName": "numberOfBeds"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "EditFacilityLocationCmsSpecialtyModalMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FacilityLocationMutationGroup",
        "kind": "LinkedField",
        "name": "facilityLocation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "FacilityLocationCmsSpecialtyModifyPayload",
            "kind": "LinkedField",
            "name": "modifyCmsSpecialty",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FacilityLocationCmsSpecialty",
                "kind": "LinkedField",
                "name": "facilityLocationCmsSpecialty",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FacilityLocation",
                    "kind": "LinkedField",
                    "name": "facilityLocation",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FacilityLocationCmsSpecialty",
                        "kind": "LinkedField",
                        "name": "cmsSpecialties",
                        "plural": true,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "FacilityLocationCmsSpecialties_CmsSpecialties"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "EditFacilityLocationCmsSpecialtyModalMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FacilityLocationMutationGroup",
        "kind": "LinkedField",
        "name": "facilityLocation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "FacilityLocationCmsSpecialtyModifyPayload",
            "kind": "LinkedField",
            "name": "modifyCmsSpecialty",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FacilityLocationCmsSpecialty",
                "kind": "LinkedField",
                "name": "facilityLocationCmsSpecialty",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FacilityLocation",
                    "kind": "LinkedField",
                    "name": "facilityLocation",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FacilityLocationCmsSpecialty",
                        "kind": "LinkedField",
                        "name": "cmsSpecialties",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CmsSpecialty",
                            "kind": "LinkedField",
                            "name": "cmsSpecialty",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "code",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CmsSpecialtyVersion",
                                "kind": "LinkedField",
                                "name": "applicableVersion",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                  },
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "numberOfBeds",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "effectiveFrom",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "effectiveTo",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a44478421d4e2435da8ec140e7ad702b",
    "id": null,
    "metadata": {},
    "name": "EditFacilityLocationCmsSpecialtyModalMutation",
    "operationKind": "mutation",
    "text": "mutation EditFacilityLocationCmsSpecialtyModalMutation(\n  $id: ID!\n  $cmsSpecialtyId: ID!\n  $numberOfBeds: DecimalInput\n  $effectiveFrom: DateOnly!\n  $effectiveTo: DateOnly!\n) {\n  facilityLocation {\n    modifyCmsSpecialty(input: {facilityLocationCmsSpecialtyId: $id, cmsSpecialtyId: $cmsSpecialtyId, numberOfBeds: $numberOfBeds, effectiveFrom: $effectiveFrom, effectiveTo: $effectiveTo}) {\n      facilityLocationCmsSpecialty {\n        id\n        facilityLocation {\n          cmsSpecialties {\n            ...FacilityLocationCmsSpecialties_CmsSpecialties\n            id\n          }\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment FacilityLocationCmsSpecialties_CmsSpecialties on FacilityLocationCmsSpecialty {\n  id\n  cmsSpecialty {\n    id\n    code\n    applicableVersion {\n      name\n      id\n    }\n  }\n  numberOfBeds\n  effectiveFrom\n  effectiveTo\n}\n"
  }
};
})();

node.hash = "78882bf192f6663bcdd64b9c7f01fcaa";

export default node;
